import * as React from "react";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Alert } from "@mui/material";

export default function SimpleSnackbar({
  open,
  handleClose,
  message,
  variant,
}) {
  const close = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    handleClose();
  };

  return (
    <div>
      <Snackbar
        open={open}
        autoHideDuration={3500}
        onClose={close}
        message={message}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity={variant}  sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
}
